import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
// import { Role } from '@/_helpers/role.js'
import NotFound from '../views/Errors/NotFound.vue'
import NetworkIssue from '../views/Errors/NetworkIssue.vue'

import Home from '../views/Home.vue'
import Login from '../views/Auth/Login.vue'
import Register from '../views/Auth/RegisterUser.vue'
import Clients from '../views/Clients/LlistaClients.vue'
import ClientAdd from '../views/Clients/ClientAdd.vue'
import ClientEdit from '../views/Clients/ClientEdit.vue'
import ClientDetails from '../views/Clients/ClientDetails.vue'
import ClientDelete from '../views/Clients/ClientDelete.vue'
import UserProfile from '../views/Auth/Profile.vue'
import Users from '../views/Auth/UsersView.vue'

import Productes from '../views/Products/LlistaProductes.vue'
import ProducteAdd from '../views/Products/ProducteAdd.vue'
import ProducteDetails from '../views/Products/ProducteDetails.vue'
import ProducteEdit from '../views/Products/ProducteEdit.vue'
import ProducteDelete from '../views/Products/ProducteDelete.vue'

import Grups from '../views/Grups/LlistaGrups.vue'
import GrupDetails from '../views/Grups/GrupDetails.vue'
import GrupEdit from '../views/Grups/GrupEdit.vue'
import GrupDelete from '../views/Grups/GrupDelete.vue'

import Centres from '../views/Centres/LlistaCentres.vue'
import CentreDetails from '../views/Centres/CentreDetails.vue'
import CentreAdd from '../views/Centres/CentreAdd.vue'
import CentreEdit from '../views/Centres/CentreEdit.vue'
import CentreDelete from '../views/Centres/CentreDelete.vue'

import CPs from '../views/ProductsClients/LlistaPCs.vue'
import CPAdd from '../views/ProductsClients/PCAdd.vue'
import CPAddFromClient from '../views/ProductsClients/PCAddFromClient.vue'
import CPDetails from '../views/ProductsClients/PCDetails.vue'
import CPEdit from '../views/ProductsClients/PCEdit.vue'
import CPDelete from '../views/ProductsClients/PCDelete.vue'

import Factures from '../views/Factures/LlistaFactures.vue'
import FacturaAdd from '../views/Factures/FacturaAdd.vue'
import FacturaEdit from '../views/Factures/FacturaEdit.vue'
import FacturaDetails from '../views/Factures/FacturaDetails.vue'
import FacturaDelete from '../views/Factures/FacturaDelete.vue'
import FacturaLanuncher from '../views/Factures/FacturaLauncher.vue'
import ProximasFacturas from '../views/Factures/ProximaFactura.vue'

import Series from '../views/Config/Series/LlistaSeries.vue'
import Bancs from '../views/Config/Bancs/LlistaBancs.vue'
import Verifactu from '../views/Config/Verifactu/VerifactuComponent.vue'

import InformeVenciments from '../views/Informes/InformeFacturesVenciment.vue'
import InformePP from '../views/Informes/InformeFacturesPP.vue'
import InformeLicenciasTaller from '../views/Informes/InformeLicenciasTaller.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: Home },

  { path: '/login', name: 'Login', component: Login },
  { path: '/profile', name: 'UserProfile', component: UserProfile, props: true },
  { path: '/users', name: 'Users', component: Users, props: true, meta: { requiresAuth: true } },
  { path: '/register', name: 'Register', component: Register, meta: { requiresAuth: true } },

  { path: '/clients', name: 'Clients', component: Clients, meta: { requiresAuth: true } },
  { path: '/clients/add', name: 'ClientAdd', component: ClientAdd, meta: { requiresAuth: true } },
  { path: '/clients/edit', name: 'ClientEdit', component: ClientEdit, props: true, meta: { requiresAuth: true } },
  { path: '/clients/details', name: 'ClientDetails', component: ClientDetails, props: true, meta: { requiresAuth: true } },
  { path: '/clients/delete', name: 'ClientDelete', component: ClientDelete, props: true, meta: { requiresAuth: true } },

  { path: '/productes', name: 'Productes', component: Productes, meta: { requiresAuth: true } },
  { path: '/productes/add', name: 'ProducteAdd', component: ProducteAdd, meta: { requiresAuth: true } },
  { path: '/productes/details', name: 'ProducteDetails', component: ProducteDetails, props: true, meta: { requiresAuth: true } },
  { path: '/productes/edit', name: 'ProducteEdit', component: ProducteEdit, props: true, meta: { requiresAuth: true } },
  { path: '/productes/delete', name: 'ProducteDelete', component: ProducteDelete, props: true, meta: { requiresAuth: true } },

  { path: '/grups', name: 'Grups', component: Grups, meta: { requiresAuth: true } },
  { path: '/grups/details', name: 'GrupDetails', component: GrupDetails, props: true, meta: { requiresAuth: true } },
  { path: '/grups/edit', name: 'GrupEdit', component: GrupEdit, props: true, meta: { requiresAuth: true } },
  { path: '/grups/delete', name: 'GrupDelete', component: GrupDelete, props: true, meta: { requiresAuth: true } },

  { path: '/centres', name: 'Centres', component: Centres, meta: { requiresAuth: true } },
  { path: '/centres/details', name: 'CentreDetails', component: CentreDetails, props: true, meta: { requiresAuth: true } },
  { path: '/centres/add', name: 'CentreAdd', component: CentreAdd, props: true, meta: { requiresAuth: true } },
  { path: '/centres/edit', name: 'CentreEdit', component: CentreEdit, props: true, meta: { requiresAuth: true } },
  { path: '/centres/delete', name: 'CentreDelete', component: CentreDelete, props: true, meta: { requiresAuth: true } },

  { path: '/cps', name: 'CPs', component: CPs, meta: { requiresAuth: true } },
  { path: '/cp/add', name: 'CPAddFromClient', component: CPAddFromClient, props: true, meta: { requiresAuth: true } },
  { path: '/cp/add', name: 'CPAdd', component: CPAdd, meta: { requiresAuth: true } },
  { path: '/cp/details', name: 'CPDetails', component: CPDetails, props: true, meta: { requiresAuth: true } },
  { path: '/cp/edit', name: 'CPEdit', component: CPEdit, props: true, meta: { requiresAuth: true } },
  { path: '/cp/delete', name: 'CPDelete', component: CPDelete, props: true, meta: { requiresAuth: true } },

  { path: '/factures', name: 'Factures', component: Factures, meta: { requiresAuth: true } },
  { path: '/factures/add', name: 'FacturaAdd', component: FacturaAdd, props: true, meta: { requiresAuth: true } },
  { path: '/factures/edit', name: 'FacturaEdit', component: FacturaEdit, props: true, meta: { requiresAuth: true } },
  { path: '/factures/details', name: 'FacturaDetails', component: FacturaDetails, props: true, meta: { requiresAuth: true } },
  { path: '/factures/delete', name: 'FacturaDelete', component: FacturaDelete, props: true, meta: { requiresAuth: true } },
  { path: '/facturar', name: 'FacturaLauncher', component: FacturaLanuncher, meta: { requiresAuth: true } },
  { path: '/factures/next', name: 'ProximasFacturas', component: ProximasFacturas, meta: { requiresAuth: true } },

  { path: '/series', name: 'Series', component: Series, meta: { requiresAuth: true } },
  { path: '/bancs', name: 'Bancs', component: Bancs, meta: { requiresAuth: true } },
  { path: '/verifactu', name: 'Verifactu', component: Verifactu, meta: { requiresAuth: true } },

  { path: '/informes/venciments', name: 'InformeVenciments', component: InformeVenciments, meta: { requiresAuth: true } },
  { path: '/informes/pp', name: 'InformePP', component: InformePP, meta: { requiresAuth: true } },
  { path: '/informes/licencias', name: 'InformeLicencias', component: InformeLicenciasTaller, meta: { requiresAuth: true } },

  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/404',
    name: '404',
    component: NotFound,
    props: true
  },
  {
    path: '/network-issue',
    name: 'network-issue',
    component: NetworkIssue
  },
  {
    path: '*',
    redirect: { name: '404', params: { resource: 'page' } }
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('user')

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!loggedIn) {
      // console.log(to.name, 'Has NOT passed')
      next('/')
    } else {
      NProgress.start()
      // console.log(to.name, 'Has passed')
      next()
    }
  } else {
    // console.log(to.name, 'Has passed')
    next()
  }
})

router.afterEach(() => {
  NProgress.done()
})

export default router
